import { Component, OnInit } from '@angular/core';
import { GroupClass } from '../../models/groupClass';
import { GroupClassService } from '../../services/group-class.service';
import { Participant } from '../../models/participant';
import { UserService } from '../../services/user.service';
import { ClassTemplate } from '../../models/classTemplate';
import { ClassTemplateService } from '../../services/class-template.service';
import { Gym } from '../../models/gym';
import { GymService } from '../../services/gym.service';

@Component({
  selector: 'app-group-class',
  templateUrl: './group-class.component.html',
  styleUrls: ['./group-class.component.scss']
})
export class GroupClassComponent implements OnInit {

  public ErrorMsg = '';
  public editMode: boolean;

  public listOfGyms: Array<Gym>;
  public listOfGroupClasses: Array<GroupClass>;
  public listOfParticipants: Array<Participant>;
  public listOfClassTemplates: Array<ClassTemplate>;

  public participantToAdd: string;
  public editingGroupClass: GroupClass;

  constructor(private classTemplateService: ClassTemplateService, private groupClassService: GroupClassService,
    private gymService: GymService, private userService: UserService) { }

  ngOnInit() {
    this.editMode = false;
    this.editingGroupClass = new GroupClass();
    this.editingGroupClass.participants = [];
    this.userService.getAllUsers().then((participants) => {
      this.listOfParticipants = participants;
      this.classTemplateService.getAllClassTemplates().then((classTemplates) => {
        this.listOfClassTemplates = classTemplates;
        this.gymService.getAllGyms().then((gyms) => {
          this.listOfGyms = gyms;
          this.groupClassService.getAllGroupClass().then((groupClasses) => {
            this.listOfGroupClasses = groupClasses;
          });
        });
      });
    });
  }

  public setParticipantsInClasses(groupClass) {
      groupClass.participants.forEach((classParticipantID, index) => {
        this.listOfParticipants.forEach(participant => {
          if (classParticipantID === participant._id) {
            groupClass.participants[index] = participant;
          }
        });
      });
  }

  public setClassTemplates(groupClass) {
    this.listOfClassTemplates.forEach(template => {
      if (groupClass.classTemplate === template._id) {
        groupClass.classTemplate = template;
      }
    });
  }

  public setGymsInClasses(groupClass) {
    this.listOfGyms.forEach(gym => {
      if (groupClass.gym === gym._id) {
        groupClass.gym = gym;
      }
    });
  }

  public addGroupClass() {

    this.editingGroupClass.participants.forEach((participant, index) => {
      this.editingGroupClass.participants[index] = participant._id;
    });

    if (this.editingGroupClass.name && this.editingGroupClass.classTemplate) {
      this.groupClassService.addGroupClass(this.editingGroupClass.gym, this.editingGroupClass)
        .subscribe(() => { this.ngOnInit(); });
    } else {
      this.ErrorMsg = 'Name, ClassTemplate and Gyms and Participants Are Required.';
    }
  }

  public addParticipant() {
    this.listOfParticipants.forEach((participant, index) => {
      if (participant._id === this.participantToAdd) {
        this.editingGroupClass.participants.push(participant);
        this.listOfParticipants.splice(index, 1);
        this.participantToAdd = null;
        return ;
      }
    });
  }

  public delGroupClass(id) {
    this.groupClassService.delGroupClass(id).subscribe(() => {
      this.ngOnInit();
    });
  }

  public setGroupClassToEdit(groupClass) {
    this.editMode = true;
    this.editingGroupClass = groupClass;
    this.setParticipantsInClasses(groupClass);
    this.setGymsInClasses(groupClass);
    this.setClassTemplates(groupClass);
    this.editingGroupClass.participants.forEach(toRemove => {
      this.listOfParticipants.forEach( (participant, index)  => {
        if (toRemove._id === participant._id) {
          this.listOfParticipants.splice(index, 1);
        }
      });
    });
  }

  public editGroupClass() {
    this.editingGroupClass.participants.forEach((participant, index) => {
      this.editingGroupClass.participants[index] = participant._id;
    });
    this.editingGroupClass.classTemplate = this.editingGroupClass.classTemplate._id;
    this.editingGroupClass.gym = this.editingGroupClass.gym._id;
    this.groupClassService.editGroupClass(this.editingGroupClass).subscribe(() => {
      this.ngOnInit();
    });
  }

  public quitEditingMode() {
    this.editMode = false;
    this.editingGroupClass.participants.forEach(participant => {
      this.listOfParticipants.push(participant);
    });
    this.editingGroupClass = new GroupClass();
    this.editingGroupClass.participants = [];
  }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/group-class/group-class.component.ts